module.exports = __webpack_public_path__ + "static/screen-classic-laptop-98049da2a17e51fc7ceb94533d99e0c2.webp";